
import {
  numberFormatter,
  currencyFormatter,
  percentFormatter,
  minutesFormatter,
  numericComparator,
} from './formatters.js';


function getMinWidth(headerName) {
  if (!headerName) return 70;

  const pixelsPerChar = 7;
  const padding = 100;
  const longestWord = headerName
    .split(' ')
    .reduce((a, b) => (a.length > b.length ? a : b));

  return Math.max(longestWord.length * pixelsPerChar + padding, 100);
}

const defaultCol = headerName => ({
  minWidth: getMinWidth(headerName),
  hide: false,
});

export const columnText = ({ field, headerName, ...column }) => ({
  field,
  headerName,
  filter: 'agTextColumnFilter',
  valueFormatter: ({ value }) => {
    if (value?.toString) return value.toString();
    return value;
  },
  type: '',
  cellClass: 'string',
  ...defaultCol(headerName),
  ...column,
});

export const columnNumber = ({ field, headerName, decimalPlace = 0, ...column }) => ({
  field,
  headerName,
  filter: 'agNumberColumnFilter',
  valueFormatter: ({ value }) => numberFormatter(value, decimalPlace),
  type: 'numericColumn',
  cellClass: 'number',
  comparator: numericComparator,
  cellStyle: { textAlign: 'right', ...column.cellStyle },
  ...defaultCol(headerName),
  ...column,
});


export const columnCurrency = ({ field, headerName, decimalPlace = 2, ...column }) => ({
  field,
  headerName,
  filter: 'agNumberColumnFilter',
  valueFormatter: ({ value }) => currencyFormatter(value, decimalPlace),
  type: 'numericColumn',
  cellClass: 'currency',
  comparator: numericComparator,
  cellStyle: { textAlign: 'right', ...column.cellStyle },
  ...defaultCol(headerName),
  ...column,
});

export const columnPercent = ({ field, headerName, decimalPlace = 2, ...column }) => ({
  field,
  headerName,
  filter: 'agNumberColumnFilter',
  valueFormatter: ({ value }) => percentFormatter(value, decimalPlace),
  type: 'numericColumn',
  cellClass: 'percent',
  comparator: numericComparator,
  cellStyle: { textAlign: 'right', ...column.cellStyle },
  filterValueGetter(params) {
    return params.getValue(params.colDef.field) * 100;
  },
  ...defaultCol(headerName),
  ...column,
});

export const columnPhone = ({...args}) => columnText({
  ...args,
  cellClass: 'phone',
  valueFormatter: ({ value }) => {
    const phoneNumber = value?.toString ? value.toString() : value;
    if (!phoneNumber) return phoneNumber;
    if (phoneNumber === 'Blocked') return phoneNumber;
    return `(${phoneNumber.substring(0, 3)}) ${phoneNumber.substring(3, 6)}-${phoneNumber.substring(6)}`;
  },
});

export const columnMinutes = ({ field, headerName, ...column }) => ({
  field,
  headerName,
  filter: 'agNumberColumnFilter',
  type: 'numericColumn',
  valueFormatter: minutesFormatter,
  comparator: numericComparator,
  cellClass: 'number',
  ...defaultCol(headerName),
  ...column,
});
